import { LanguageInput } from "../input/LanguageInput";
import { PHPResponse } from "../PHPResponse";
import { PHPAdress, PHPAdresses } from "../PHPAdress";
import { PHPRequest } from "../PHPRequest";
import { EmailInput } from "./UserSignUpRequest";
export class UserLoginStatusResponse extends PHPResponse
{
  userName:string;
}

export class UserLoginStatusRequest extends PHPRequest<PHPAdress,LanguageInput,UserLoginStatusResponse>
{
  static readonly ADRESS = PHPAdresses.USER_LOGIN_STATUS;

  constructor(){ super( UserLoginStatusRequest.ADRESS ); }

}
